module.exports = __webpack_public_path__ + "static/media/ic_edit_blue.83a16b9b.svg";